import Dropdown from '@/components/Dropdown'
import { Film, Archive, Inbox, Check, X } from 'react-feather'
import analytics from '@/utils/analytics'

export default function VideosOptions({ className = '', filter, setFilter }) {
  function handleMenuClick(key) {
    analytics.track('Videos option clicked', { key })
    setFilter(key)
  }

  const options = [
    {
      name: 'All Videos',
      value: 'all',
      selected: filter === 'all',
      icon: (
        <Film className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    },
    {
      name: 'Archived',
      value: 'archived',
      selected: filter === 'archived',
      icon: (
        <Archive className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    },
    {
      name: 'Not Archived',
      value: 'unarchived',
      selected: filter === 'unarchived',
      icon: (
        <Inbox className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    },
    {
      name: 'Finished',
      value: 'finished',
      selected: filter === 'finished',
      icon: (
        <Check className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    },
    {
      name: 'Not Finished',
      value: 'unfinished',
      selected: filter === 'unfinished',
      icon: (
        <X className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    },
  ]

  return (
    <Dropdown
      options={options}
      position="left"
      className={className}
      onChange={handleMenuClick}
      selected={filter}
    />
  )
}
